import PropTypes from "prop-types"
import React from "react"
import { useFormContext } from "react-hook-form"
import TimeRangePicker from "src/main/Settings/PublicProfile/Fuel/TimeRangePicker"

import Button from "src/components/Button"
import Form from "src/components/Form"

import useHover from "src/hooks/use_hover"

const DayScheduleSelector = ({ day, disabled }) => {
  const {
    register,
    watch,
    setValue,
    formState: { errors },
    clearErrors,
  } = useFormContext()
  const dayKey = `fuelDockAvailability.days.${day.toLowerCase()}`
  const isEnabled = watch(`${dayKey}.enabled`)
  const [hoverRef, isHovered] = useHover()

  const dayErrors = errors.fuelDockAvailability?.days?.[day.toLowerCase()]

  const handleApplyToAll = () => {
    const allDays = [
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
      "sunday",
    ]
    allDays.forEach((d) => {
      setValue(`fuelDockAvailability.days.${d}.enabled`, isEnabled)
      setValue(
        `fuelDockAvailability.days.${d}.timeRange`,
        watch(`${dayKey}.timeRange`)
      )
    })
  }

  return (
    <div
      className="grid h-12 grid-cols-12 items-center gap-2"
      ref={hoverRef}
      data-testid="day-schedule-selector"
    >
      <div className="col-span-4 flex items-center space-x-2">
        <Form.Checkbox
          {...register(`${dayKey}.enabled`)}
          onChange={(e) => {
            setValue(`${dayKey}.enabled`, e.target.checked)
            if (e.target.checked) {
              clearErrors(dayKey)
            }
          }}
          compact
          disabled={disabled}
        >
          <span className="font-semibold">{day}</span>
        </Form.Checkbox>
        <div className="hidden lg:block">
          {isHovered && isEnabled && (
            <Button variant="secondary" small onClick={handleApplyToAll}>
              Apply to all
            </Button>
          )}
        </div>
      </div>
      <div className="col-span-8 flex items-center">
        {isEnabled ? (
          <TimeRangePicker
            dayKey={dayKey}
            disabled={disabled}
            dayErrors={dayErrors}
          />
        ) : (
          <span>No availability</span>
        )}
      </div>
    </div>
  )
}

DayScheduleSelector.propTypes = {
  day: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
}

export default DayScheduleSelector
